module.exports = __webpack_public_path__ + "img/e-max.ab30b329.png";